<template>
  <!-- FOR COMPONENT PROPS, SEE: -->
  <!-- https://www.npmjs.com/package/vue-element-loading -->
  <BaseVueElementLoading v-bind="$attrs">

    <!-- Overwrite the spinner with the AnimatedLogoLoader by default, -->
    <!-- while also allowing the user to pass in their own content optionally -->
    <AnimatedLogoLoader />

  </BaseVueElementLoading>
</template>

<script>
// FOR COMPONENT PROPS, SEE:
// https://www.npmjs.com/package/vue-element-loading

import BaseVueElementLoading from 'vue-element-loading';

import AnimatedLogoLoader from './AnimatedLogoLoader.vue';

export default {
  components: {
    BaseVueElementLoading,
    AnimatedLogoLoader
  },
};
</script>
